import { Directive, Input, OnInit, ElementRef, SimpleChanges, OnChanges } from '@angular/core';
import * as ics from 'ics';
import { applyCalendarDescriptionToIcsEvent } from 'ag-common-svc/lib/utils/calendar-event-description.utils';

@Directive({
  selector: '[shrAddToCalendar]',
})
export class AddToCalendarDirective implements OnInit, OnChanges {
  @Input() shrAddToCalendar: ics.EventAttributes; // Input property to receive event details

  private objectUrl?: string;

  constructor(private el: ElementRef) {}

  ngOnInit() {
    this.tryGenerate();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['shrAddToCalendar']) {
      this.tryGenerate();
    }
  }

  private tryGenerate() {
    if (!this.shrAddToCalendar) {
      return;
    }

    this.generateICalData();
  }

  generateICalData() {
    const event = { ...this.shrAddToCalendar };

    applyCalendarDescriptionToIcsEvent(event);

    const { error, value } = ics.createEvent(event);

    if (!error && value) {

      if (this.objectUrl) {
        URL.revokeObjectURL(this.objectUrl);
      }
      // Create a Blob with the iCalendar data
      const blob = new Blob([value], { type: 'text/calendar;charset=utf-8' });
      this.objectUrl = URL.createObjectURL(blob);
      this.el.nativeElement.href = this.objectUrl;
    }
  }
}
